import './styles.scss'
import React from 'react'
import { getStaticImage } from 'utils/statics'

export default class FilePreview extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onRemoveFile = this.onRemoveFile.bind(this)
  }

  onRemoveFile(e) {
    e.preventDefault()

    const { id } = this.props

    this.props.onRemoveFile(id)
  }

  render() {
    const { url, shortUrl, type, mimeType, mimeSubtype, name, thumb, iconCleanedClose, withVirus } = this.props
    const src = getImageSrc({ type, mimeType, mimeSubtype, thumb, url })

    return (
      <div className='file-preview' hidden={this.props.hidden}>
        <a href={url || shortUrl} target='_blank' className='link-preview' rel='noopener noreferrer'>
          <div className={`file ${withVirus ? 'file__virus' : ''}`}>
            {iconCleanedClose ? (
              <button
                className='file__close'
                onClick={this.onRemoveFile}
                hidden={this.props.disabled}
              >
                <figure>
                  <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
                </figure>
              </button>
            ) : (
              <i className='fa fa-times-circle' onClick={this.onRemoveFile} hidden={this.props.disabled} />
            )}
            <img src={src} height={50} alt='' />
            {name && <div className='file-name'>{name}</div>}
          </div>
        </a>
      </div>
    )
  }
}

function getImageSrc({ type, mimeType, mimeSubtype, thumb, url }) {
  const isImage = !!(/^image/.test(type || mimeType) || thumb)

  if (isImage && ("image/tiff" === type || mimeSubtype === 'tiff')) return './img/image-default.png'
  if (isImage && (thumb || url)) return thumb || url

  const isVideo = /^video/.test(type || mimeType)
  if (isVideo) return './img/file-default-video.svg'

  const isAudio = !!(/^audio/.test(type || mimeType || mimeSubtype))
  if (isAudio) return getStaticImage('/icons/orange-brand/icon-microphone.svg')

  return './img/file-default.png'
}
